import { useLocation, Navigate } from "react-router-dom";
import useDecodeToken from "../../hooks/useDecodeToken";
import { useSelector } from "react-redux";
import Cookies from "js-cookie";
export default function RequireAuth({ children, role }) {
  const location = useLocation();
  const { decryptToken } = useDecodeToken();
  const userToken = useSelector((state) => state.auth.userToken);
  const user = decryptToken(userToken ? userToken : false);

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!user.roles.includes(role)) {
    return <Navigate to="/access_denied" state={{ from: location }} replace />;
  }

  return children;
}
